"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var core_1 = require("@theme-ui/core");
var react_1 = require("react");
var Link_1 = __importDefault(require("../Link"));
var ButtonLink = function (_a) {
    var children = _a.children, href = _a.href, onClick = _a.onClick;
    return ((0, core_1.jsx)(Link_1.default, { to: href, onClick: onClick, sx: {
            variant: "buttons.primary",
        } }, children));
};
exports.default = (0, react_1.memo)(ButtonLink);
